import React from 'react';
import SectionTitle from './SectionTitle';
import SectionText from './SectionText';
import { roomsMainText } from '../data/rooms/roomsMainTextRD';

// the following imports contents to populate the textual components
import './Main.css';
import './RoomsSejour.css';

function Rooms(props) {
    var hotelHeading = '';
    if (props.language === 'en') {
        hotelHeading = 'Red Door Lounge';
    } else if (props.language === 'jp') {
        hotelHeading = 'レッドドアロッジ';
    } else if (props.language === 'ch1') {
        hotelHeading = 'Red Door Lounge';
    } else if (props.language === 'ch2') {
        hotelHeading = 'Red Door Lounge';
    } else {}

    // scroll to the top of the page when coming from another route
    window.scroll(0,0);

    return (
        <div className='roomsContainer'>

            {/* This block is rendering of rooms section of the page */}
            <SectionTitle ids='rooms' title={hotelHeading} />

            <div className='sectionMain'>
                <SectionText text={roomsMainText} language={props.language} />
            </div>
        </div>
    )
}

export default Rooms;